var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "roundcube-bridge-container" },
    [
      _vm.isFilePickerOpen
        ? _c("FilePicker", {
            attrs: {
              name: _vm.t(
                "mail_roundcube_bridge",
                "Choose a file to add as attachment"
              ),
              buttons: _vm.filePickerButtons,
            },
            on: { close: _vm.onFilePickerClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFileSaverOpen
        ? _c("FilePicker", {
            attrs: {
              name: _vm.t(
                "mail_roundcube_bridge",
                "Choose a folder to store the attachment in"
              ),
              buttons: _vm.fileSaverButtons,
              "allow-pick-directory": true,
              multiselect: false,
              "mimetype-filter": ["httpd/unix-directory"],
            },
            on: { close: _vm.onFileSaverClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShareLinkPickerOpen
        ? _c("FilePicker", {
            attrs: {
              name: _vm.t(
                "mail_roundcube_bridge",
                "Choose a file to share as a link"
              ),
              buttons: _vm.shareLinkPickerButtons,
              multiselect: false,
            },
            on: { close: _vm.onShareLinkPickerClose },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isShareOptionsOpen && _vm.pendingShareWithOptionsRequest
        ? _c("ShareOptionsForm", {
            attrs: {
              "file-path": _vm.pendingShareWithOptionsRequest.path,
              "file-name": _vm.pendingShareWithOptionsRequest.filename,
              "server-error": _vm.shareServerError,
              "server-error-detail": _vm.shareServerErrorDetail,
            },
            on: {
              submit: _vm.onShareOptionsSubmit,
              cancel: _vm.onShareOptionsCancel,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }